import { Translations } from '../types';

export const zh: Translations = {
  common: {
    loading: '加载中...',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    next: '下一步',
    submit: '提交',
    search: '搜索',
    filter: '筛选',
    all: '全部',
    viewAll: '查看全部',
    copy: '复制',
    copied: '已复制！',
    success: '成功',
    error: '错误',
    close: '关闭',
  },
  nav: {
    home: '首页',
    linkExchange: '链接交易所',
    rebate: '返佣',
    exchanges: '交易所',
    withdraw: '提现',
    history: '历史记录',
    checkIn: '签到',
    profile: '个人中心',
    overview: '概览',
    rewardHub: '奖励中心',
    settings: '设置',
  },
  dashboard: {
    title: '欢迎，{name}！',
    subtitle: '您的账户概览',
    balance: '余额',
    totalEarned: '总收益',
    pendingRebate: '待处理返佣',
    availablePoints: '可用XP',
    recentRebates: '最近返佣',
    recentWithdrawals: '最近提现',
  },
  linkExchange: {
    title: '链接交易所账户',
    subtitle: '连接您的交易所 UID 以启用自动费用跟踪',
    exchange: '交易所',
    uid: 'UID',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    linkAccount: '链接账户',
    linkedAccounts: '已链接账户',
    status: '状态',
    active: '活跃',
    inactive: '未活跃',
    delete: '删除账户',
    selectExchange: '选择交易所',
    enterUID: '输入 UID',
    enterApiKey: '输入 API Key',
    enterApiSecret: '输入 API Secret',
    accountLinked: '账户链接成功',
    accountDeleted: '账户删除成功',
    binance: 'Binance',
    bybit: 'Bybit',
    okx: 'OKX',
    gate: 'Gate.io',
  },
  rebate: {
    title: '交易费用返佣',
    subtitle: '自动返佣支付历史',
    totalRebate: '总返佣',
    pendingRebate: '待处理返佣',
    balance: '余额',
    withdraw: '提现',
    rebateHistory: '返佣历史',
    date: '日期',
    amount: '金额',
    status: '状态',
    completed: '已完成',
    pending: '待处理',
    failed: '失败',
    description: '描述',
    autoRebate: '自动返佣',
    autoRebateDesc: '系统将自动将交易费用返佣到您的账户。处理时间：1-3 个工作日。',
  },
  withdraw: {
    title: '提现',
    subtitle: '提现资金到您的钱包',
    availableBalance: '可用余额',
    withdrawAmount: '提现金额',
    walletAddress: '钱包地址（或UID）',
    network: '网络',
    selectNetwork: '选择网络',
    enterAmount: '输入金额',
    enterWalletAddress: '输入钱包地址（或UID）',
    withdraw: '提现',
    minWithdraw: '最低提现：{amount}',
    fee: '手续费',
    receiveAmount: '您将收到',
    withdrawHistory: '提现历史',
    processing: '处理中',
    completed: '已完成',
    failed: '失败',
    trc20: 'TRC20',
    erc20: 'ERC20',
    bep20: 'BEP20',
    pleaseEnterAmount: '请输入有效金额',
    pleaseEnterWallet: '请输入钱包地址',
    pleaseSelectNetwork: '请选择网络',
    invalidAmount: '无效金额',
    amountTooLow: '金额低于最低提现额',
    insufficientBalance: '余额不足',
    confirmWithdrawal: '确认提现',
    withdrawalSubmitted: '提现请求提交成功！查看历史记录以了解领取状态。',
    withdrawalFailed: '提现失败',
    note: '注意',
    withdrawalNote: 'Gas费将从提现金额中扣除',
  },
  history: {
    title: '交易历史',
    subtitle: '查看所有交易和提现记录',
    transactions: '交易',
    withdrawals: '提现',
    rebates: '返佣',
    date: '日期',
    type: '类型',
    amount: '金额',
    status: '状态',
    noTransactions: '未找到交易',
    noWithdrawals: '未找到提现',
    noRebates: '未找到返佣',
    claimNow: '立即领取',
    claiming: '领取中...',
    readyToClaim: '准备从智能合约领取',
    claimedSuccessfully: '领取成功！',
    failedToClaim: '领取失败',
    noMoreItems: '没有更多项目',
    payGas: '支付Gas',
    claimed: '已领取',
    noHistoryFound: '未找到历史记录',
    statusCompleted: '已完成',
    statusPending: '待处理',
    statusFailed: '失败',
    statusProcessing: '处理中',
    statusRejected: '已拒绝',
  },
  checkIn: {
    title: '每日签到',
    subtitle: '每天签到以获得积分',
    checkIn: '签到',
    checkedIn: '已签到',
    todayPoints: '今日XP',
    totalPoints: '总XP',
    points: 'XP',
    redeem: '兑换',
    rewards: '奖励',
    vouchers: '优惠券',
    linkReward: '链接奖励',
    linkExchange: '链接交易所账户',
    linkRewardDesc: '链接您的交易所账户以获得奖励积分',
    rewardHistory: '奖励历史',
    availableRewards: '可用奖励',
    voucher: '优惠券',
    gift: '礼物',
    pointsRequired: '所需XP',
    redeemNow: '立即兑换',
    redeemed: '已兑换',
    noRewards: '暂无可用奖励',
    shop: '商店',
    myCodes: '我的代码',
    backButton: '← 返回',
    noPointsHistory: '没有XP历史',
    myRedeemedCodes: '我的兑换代码',
    yourCode: '您的代码：',
    codeCopied: '代码已复制！',
    noRedeemedYet: '还没有兑换的奖励',
    dailyCheckIn: '每日签到',
    tasks: '任务',
    checkedInSuccessfully: '签到成功！',
    checkInFailed: '签到失败',
    claimedTask: '任务领取成功！',
    failedToClaimTask: '领取任务失败',
    insufficientPoints: 'XP不足',
    redeemFailed: '兑换失败',
    special: '特殊',
    social: '社交',
    trading: '交易',
    watchAd: '观看广告',
    available: '可用',
    completed: '已完成',
    comingSoon: '即将推出',
    times: '次',
    weeklyLeaderboard: '每周XP排行榜',
    leaderboardSubtitle: '本周最佳表现者',
    yourRank: '您的排名',
    yourXP: '您的XP',
    you: '您',
    noLeaderboardData: '暂无排行榜数据',
    prize: '奖品',
  },
  profile: {
    title: '个人中心',
    accountInfo: '账户信息',
    telegramId: 'Telegram ID',
    joinDate: '加入日期',
    language: '语言',
    english: '英语',
    vietnamese: '越南语',
    spanish: '西班牙语',
    portuguese: '葡萄牙语',
    chinese: '中文',
    indonesian: '印尼语',
    emailSettings: '邮箱设置',
    notSet: '未设置',
    logout: '退出登录',
    logoutConfirm: '您确定要退出登录吗？',
  },
  login: {
    title: 'CashBackHub',
    subtitle: '交易费用返佣系统',
    description: 'Telegram Mini App',
    hint: '请从 Telegram 打开应用',
    login: '登录',
  },
  exchanges: {
    title: '交易所',
    subtitle: '选择您的推荐类型',
    chooseReferralType: '选择您的推荐类型',
    exchangeReferral: '交易所推荐',
    linkYourUid: '链接您的UID',
    copyTrade: '跟单交易',
    followTrades: '跟随我们的交易',
    filterByExchange: '按交易所筛选：',
    allExchanges: '所有交易所',
    accounts: '个账户',
    account: '账户',
    connected: '已连接',
    uidCopied: 'UID已复制！',
    totalRebate: '总返佣',
    transactionVolume: '交易量',
    waitingForSync: '等待同步',
    cashbackHubRebate: 'CashbackHub返佣',
    viewReason: '查看原因',
    reconnect: '重新连接',
    noAccounts: '还没有交易所账户',
    rejectionReason: '拒绝原因',
    exchangeConnected: '交易所连接成功！',
    notConfigured: '尚未配置',
    noExchangesAvailable: '没有可用的交易所',
    pleaseContactSupport: '请联系我们的支持团队为您的账户设置交易所。',
    allAccounts: '全部',
    activeAccounts: '活跃',
    pendingAccounts: '待审核',
    rejectedAccounts: '已拒绝',
    totalProfit: '总利润',
    noCopyTradeAccounts: '还没有跟单账户',
    rejectionReasonText: '此UID尚未在我们的推荐系统中注册。请联系我们的支持团队@backcashhub获取详细说明，了解如何完成注册流程！',
  },
  settings: {
    title: '设置',
    subtitle: '自定义您的体验并管理您的账户详情',
    telegramNotifications: 'Telegram 通知',
    profile: '个人资料',
    telegramNotificationsDesc: '通过 Telegram 获取即时更新',
    uid: 'UID',
    connected: '已连接',
    connect: '连接',
    emailVerification: '邮箱验证',
    emailAddress: '邮箱地址',
    sendVerificationCode: '发送验证码',
    sending: '发送中...',
    verificationCode: '验证码',
    enterCode: '输入邮箱中的6位数验证码',
    changeEmail: '更换邮箱',
    resendCode: '重新发送',
    verifying: '验证中...',
    verifyEmail: '验证邮箱',
    codeExpired: '验证码已过期。请请求新的验证码。',
    invalidCode: '无效的验证码。请重试。',
    verificationSent: '验证码发送成功！请查收邮件。',
    emailVerified: '邮箱验证成功！',
    failedToSend: '发送验证码失败。请重试。',
    failedToVerify: '验证邮箱失败。请重试。',
    enterEmailPlaceholder: 'your.email@example.com',
    enterCodeDesc: '输入邮箱中的6位数验证码',
  },
  copyTrade: {
    title: '跟单交易',
    notConfigured: '尚未配置',
    noExchangesAvailable: '没有可用的交易所',
    pleaseContactSupport: '请联系我们的支持团队为您的账户设置交易所。',
    linkCopyTradeAccount: '链接跟单账户',
    selectExchange: '选择交易所',
    step1: '步骤1：点击下方按钮跟单',
    openCopyTradeLink: '打开跟单链接',
    clickToCopyTrade: '点击打开我们的跟单链接并按照说明操作',
    step2: '步骤2：输入您的UID',
    enterYourUid: '输入您的UID',
    enterUidPlaceholder: '输入您在交易所的UID',
    submit: '提交',
    submitting: '提交中...',
    pleaseEnterUid: '请输入您的UID',
    pleaseSelectExchange: '请选择交易所',
    pleaseSelectBot: '请选择一个机器人',
    submittedSuccessfully: '跟单账户提交成功！等待审批。',
    accountRejectedPleaseResubmit: '您的账户已被拒绝。请使用正确的信息重新提交。',
    disabled: '已禁用',
    accountDisabledMessage: '此账户已被禁用。请联系支持获取更多信息。',
    submitFailed: '提交跟单账户失败',
  },
  rules: {
    title: '返佣规则',
    description: '基于利润里程碑的返佣百分比：',
    profitRange: '利润范围',
    rebatePercentage: '返佣',
    range1: '$100 - $200',
    range2: '$201 - $300',
    range3: '$301 - $400',
    range4: '$500+',
    note: '返佣基于扣除交易所返佣后的增量利润计算。',
    noRules: '暂无返佣规则',
  },
};

